import CacheCleaner from "./CacheCleaner";
import HorseCategorieCleaner from "./HorseCategorieCleaner";

export default class CategorieLienCleaner extends CacheCleaner {

	async onMutation(liens_ids) {
		await HorseCategorieCleaner.inst().onCategorieLienMutation(liens_ids)
	}
}
